import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import FAQSection from "./FAQSection";
import Impactgrid from "./Impactgrid";
import Testimonial from './Testimonial'
import Footer from "./Footer";
import InfoSection from "./InfoSection";
import WhatsAppSupport from "./WhatsappSupport";
import ScrollToTop from "./ScrollToTop";
import Slider from "./Marquee";
import EnquiryForm from "./Enquiry";
import ApplicationSteps from "./ApplicaitonSteps";
import StudyAbroadServices from "./whyappuni";
import { MegaMenu } from "./MegaMenu";
const testimonials = [
 
  {
    name: "ANAM SHARMA",
    role: "Student",
    message:
      "Highly professional, experts at their work, very supportive, available 24*7 about doubt and provided end to end complete solutions for my international education. This would not have been possible without them as I have been working on it for a long time with other agents which did not work. So do not think again and contact the Application Uni team today.",
    stars: 5,
  },
  {
    name: "SHUBHAM AGGARWAL",
    role: "Student",
    message:
      "When I came to know about application Uni i was confused whether to choose the UK and Canada for my post graduation. But, the prodigious & logical guidance of Sundeep Sir really helped me. Application Uni also helped me with application with various colleges & universities & not only that they supported me for my profile building & my visa too. ",
    stars: 5,
  },
  {
    name: "HARNOOR SINGH",
    role: "Student",
    message:
      "Thank you to the Application Uni team, specially Sundeep Sir & Anshika Maam for the tireless effort to make my dream for studying abroad a success. I am very excited that I got a 4 years visa to Canada and all the credit goes to the Application Uni.",
    stars: 5,
  },
  {
    name: "NAVJOT SINGH",
    role: "Student",
    message:
      "I had applied to universities across the U.K. with Application Uni and got admitted in most of them. Not only Application Uni helped me with applications in different universities but helped me with profile building and visa too. They are a very professional and well done team. I will genuinely recommend Application Uni to all my friends and relatives.",
    stars: 5,
  },
  {
    name: "PARVINDER KAUR",
    role: "Student",
    message:
      "The whole team of Application Uni recommended the best universities, relevant courses, their guidance is exceptional and they are truly out of the crowd. Their highly experienced team is unmatchable and I got admitted to Toronto Metropolitan University of Canada, looking forward to a bright future ahead here now.",
    stars: 5,
  },
];

const ProgramsPage = () => {
  const cards = [
    { id: 1, image: 'https://t4.ftcdn.net/jpg/00/44/48/17/240_F_44481783_gUghXUoAVHGr6adHMWANhXIrcWc8ZBp5.jpg' },
    { id: 2, image: 'https://t4.ftcdn.net/jpg/00/44/48/17/240_F_44481783_gUghXUoAVHGr6adHMWANhXIrcWc8ZBp5.jpg' },
    { id: 3, image: 'https://t4.ftcdn.net/jpg/00/44/48/17/240_F_44481783_gUghXUoAVHGr6adHMWANhXIrcWc8ZBp5.jpg' },
    { id: 4, image: 'https://t4.ftcdn.net/jpg/00/44/48/17/240_F_44481783_gUghXUoAVHGr6adHMWANhXIrcWc8ZBp5.jpg' },
    { id: 5, image: 'https://t4.ftcdn.net/jpg/00/44/48/17/240_F_44481783_gUghXUoAVHGr6adHMWANhXIrcWc8ZBp5.jpg' },
    { id: 6, image: 'https://t4.ftcdn.net/jpg/00/44/48/17/240_F_44481783_gUghXUoAVHGr6adHMWANhXIrcWc8ZBp5.jpg' },
    { id: 7, image: 'https://t4.ftcdn.net/jpg/00/44/48/17/240_F_44481783_gUghXUoAVHGr6adHMWANhXIrcWc8ZBp5.jpg' },
    { id: 8, image: 'https://t4.ftcdn.net/jpg/00/44/48/17/240_F_44481783_gUghXUoAVHGr6adHMWANhXIrcWc8ZBp5.jpg' },
    { id: 9, image: 'https://t4.ftcdn.net/jpg/00/44/48/17/240_F_44481783_gUghXUoAVHGr6adHMWANhXIrcWc8ZBp5.jpg' },
    { id: 10, image: 'https://t4.ftcdn.net/jpg/00/44/48/17/240_F_44481783_gUghXUoAVHGr6adHMWANhXIrcWc8ZBp5.jpg' },
    { id: 11, image: 'https://t4.ftcdn.net/jpg/00/44/48/17/240_F_44481783_gUghXUoAVHGr6adHMWANhXIrcWc8ZBp5.jpg' },
    { id: 12, image: '  https://t4.ftcdn.net/jpg/00/44/48/17/240_F_44481783_gUghXUoAVHGr6adHMWANhXIrcWc8ZBp5.jpg' },
  ];
  return (
    <div className=" min-h-screen">

      {/* Header Section */}
      {/* <Navbar /> */}
      <MegaMenu />
      {/* Hero Section */}

      <div className="relative h-[100vh]">
        {/* Background Image */}
        <div className="absolute inset-0 h-full">
          <img
            src="https://www.studyabroadguide.com/wp-content/uploads/The-10-Best-Universities-For-International-Students-in-2022.jpg
"
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Overlay Content */}
        <div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-6 md:px-8 lg:px-12 bg-black bg-opacity-60 lg:space-y-5 space-y-2">

          <h1 className="text-white text-2xl sm:text-4xl md:text-5xl lg:text-7xl noto w-full sm:w-3/4 font-semibold">
            AI Powered eligibility Checker
          </h1>


          <p className=' text-white '>Check your eligibility in seconds and apply in minutes.</p>
          

          <Link to="/eligibility" className="w-full sm:w-auto">
            <button className="bg-blue-500 text-white px-4 sm:px-6 py-[10px] rounded-full font-medium shadow-lg hover:bg-blue-400 hover:text-white transition-all sm:w-60 md:w-72 lg:w-[400px] poppins text-xs sm:text-sm md:text-base">
              Check Eligibility
            </button>
          </Link>

        </div>

      </div>

      <main className="container py-10 mx-auto">
        {/* Partner Universities Section */}

        <ApplicationSteps />

        <StudyAbroadServices />
        {/* Faq SEction, */}
        <FAQSection />

        {/* AI-powered Check My Eligibility Section */}

        <InfoSection />

        {/* Impact Section */}
        <Impactgrid />

        <EnquiryForm />
        <div className=' md:px-8'>
          <Testimonial testimonials={testimonials} />
        </div>
      </main>

      {/* Footer Section */}
      <Footer />
      <ScrollToTop />
      {/* <WhatsAppSupport/> */}
    </div>
  );
};

export default ProgramsPage;
